import { Link, LinkProps } from "react-router-dom";
import { IconTabProps, Tab } from "../Tabs";

export function TabLink(props: Omit<IconTabProps, "component"> & Omit<LinkProps, "to">) {
    return <Tab {...props} component={Link} to={props.value} />;
}
